import { Button, Text, Link as VuiLink } from '@village/ui';
import { device } from 'citymd/constants/device';
import { rem } from 'polished';
import styled from 'styled-components';

export const Title = styled(Text)`
    text-align: center;
    margin-top: ${rem(32)};
`;

export const SubmitButton = styled(Button)`
    display: block;
    height: ${rem(48)};
    margin: 0 auto;
    min-width: ${rem(448)};
    width: auto;

    @media ${device.maxMobile} {
        width: 100%;
        min-width: auto;
    }
`;

export const TermsAndConditions = styled(Text)`
    text-align: center;
`;

export const Form = styled.form`
    display: grid;
    gap: ${rem(40)};
    margin-bottom: ${rem(40)};
`;

export const Link = styled(VuiLink)`
    font-family: CeraProBold, arial, sans-serif;
    text-decoration: underline;
    color: ${({ theme }) => theme.vui.colors.text.link.secondary.default};
    cursor: pointer;

    @media (hover: hover) {
        &:hover {
            color: ${({ theme }) => theme.vui.colors.text.link.secondary.default};
        }
    }
`;
